import React, { useState, useRef, useEffect } from "react";
import $ from "jquery";
import { Link, useNavigate } from "react-router-dom";
// import { CSVLink } from "react-csv";
// import jsPDF from "jspdf";
import "jspdf-autotable";
import Chip from "@mui/material/Chip";
// import { CloseOutlined, Pending } from "@mui/icons-material";
import Paper from "@mui/material/Paper";
// import moment from "moment";
import { AxiosInstance } from "../../../../axios";
import { R_PER_PAGE } from "../../../../labels";
import { styled } from "@mui/material/styles";
// import DatePickerSample from "../../DatePicker";
import Loader from "../../Loader";
// import { ExportTableToPdf } from "../../../ReusuableComponent/ExportTableToPdf";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import toast from "react-hot-toast";

function CashPendingPayment(props) {
  //usestate
  const [csvData, setCsvData] = useState([]);
  const moment = require("moment-timezone");
  const [listData, setListData] = useState([]);
  const txtBSearch = useRef(null); //search icon
  let page = R_PER_PAGE;

  // use state
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  // const [updatePag, setUpdatePag] = useState(false);
  // const [updatePagDis, setUpdatePagDis] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  // const [downloadCSV, setDownloadCSV] = useState([]);
  // const [downloadPDF, setDownloadPDF] = useState([]);
  const [updateListData, setUpdateListData] = useState(listData);
  const [dCourse, setDcourse] = useState([]);
  const [dCourses, setDcourses] = useState([]);
  const [dCoursebatch_name, setDcoursebatch_name] = useState([]);
  const [dCoursesbatch_name, setDcoursesbatch_name] = useState([]);
  const [isOpen, setIsOpen] = useState({
    status: false,
    startDate: false,
    section: false,
    location: false,
    batch_name: false,
    category: false,
    pay_duedate: false,
  });
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });

  const [appDataDue, setAppDataDue] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let staff_loc_name = null;
  let staff_loc_id = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      staff_loc_id = user.staff_loc_id;
      staff_loc_name = user.staff_loc_name;
    }
  } else {
    console.log("UserId Not available");
  }

  const [updateChipData, setUpdateChipData] = useState([]);

  const [status, setStatus] = useState([]);
  const [appOn, setAppOn] = useState([]);
  const [appOn_due, setAppOn_due] = useState([]);
  const [typeOn, setTypeOn] = useState([]);
  const [location, setLocation] = useState([]);
  const [batch_name, setBatch_name] = useState([]);
  const [section, setSection] = useState([]);

  let filterStatus = [];
  let filterType = [];
  let filterApplyed = [];
  let filterApplyedDue = [];
  let filterSearch = [];
  let filterlocation = [];
  let filterbatch_name = [];
  let filtersection = [];
  // filter useEffect

  useEffect(() => {
    loadChipdata();
  }, []);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    filterStatus = status;
  }, [status]);

  useEffect(() => {
    filterlocation = location;
  }, [location]);

  useEffect(() => {
    filterbatch_name = batch_name;
  }, [batch_name]);

  useEffect(() => {
    filtersection = section;
  }, [section]);

  useEffect(() => {
    filterType = typeOn;
  }, [typeOn]);

  useEffect(() => {
    filterApplyed = appOn;
  }, [appData]);

  useEffect(() => {
    filterApplyedDue = appOn_due;
  }, [appDataDue]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);

  useEffect(() => {
    if (props.activeTab === 2) {
      loadChipdata();
    }
  }, []);

  useEffect(() => {
    if (props.activeTab === 2) {
      loadListdata();
    }
  }, [props.activeTab]);

  useEffect(() => {
    if (props.activeTab === 2) {
      loadListdata();
    }
  }, [updateChipData]);

  function updateStateData() {
    filterStatus = status;
    filterType = typeOn;
    filterApplyed = appOn;
    filterlocation = location;
    filterbatch_name = batch_name;
    filtersection = section;

    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  const handlePayFee = (CourseDetail) => {
    let PayDue = "2";
    let PayTab = "2";
    navigate(`/CashPayment/payFee`, {
      state: {
        CourseDetail,
        PayDue,
        PayTab,
        user_type: 1,
      },
    });
  };

  //sorting function

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    // setSortColumn(sortKey);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
    setSortColumn(sortKey);
  };

  // filter checkbox update

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (
      name === "Upcoming" ||
      name === "Ongoing" ||
      name === "Completed" ||
      name === "WaitForApproval" ||
      name === "Rejected" ||
      name === "Approved" ||
      name === "OnHold"
    ) {
      if (checked) {
        // setStatus([...status, value]);
        setStatus([...status, { id: value, name: name, type: "status" }]);
      } else {
        setStatus(status.filter((item) => item.id !== value));
      }
    } else if (
      name === "course" ||
      name === "TestBatch" ||
      name === "SpecialClass" ||
      name === "Counselling" ||
      name === "MockInterview" ||
      name === "ModelExam"
    ) {
      if (checked) {
        setTypeOn([...typeOn, { id: value, name: name, type: "type" }]);
      } else {
        setTypeOn(typeOn.filter((item) => item.id !== value));
      }
    } else if (name === "A" || name === "B" || name === "C" || name === "D") {
      if (checked) {
        // setStatus([...status, value]);
        setSection([...section, { id: value, name: name, type: "section" }]);
      } else {
        setSection(section.filter((item) => item.id !== value));
      }
    } else if (names === "location") {
      if (checked) {
        // setStatus([...status, value]);
        setLocation([...location, { id: value, name: name, type: "location" }]);
      } else {
        setLocation(location.filter((item) => item.id !== value));
      }
    } else if (names === "batch_name") {
      if (checked) {
        // setStatus([...status, value]);
        setBatch_name([
          ...batch_name,
          { id: value, name: name, type: "batch_name" },
        ]);
      } else {
        setBatch_name(batch_name.filter((item) => item.id !== value));
      }
    }
  };
  const handleFilterCourseSearch = (event) => {
    const searchInput = event.target.value;
    if (searchInput !== "") {
      const matchingObjects = dCourse.filter(
        (item) => item && item.toLowerCase().includes(searchInput.toLowerCase())
      );
      // Do something with the matchingObjects, such as updating state or displaying them in the UI
      setDcourses(matchingObjects);
    } else {
      setDcourses(dCourse);
    }
  };

  const handleFilterCourseBSearch = (event) => {
    const searchInput = event.target.value;
    if (searchInput !== "") {
      const matchingObjects = dCoursebatch_name.filter(
        (item) => item && item.toLowerCase().includes(searchInput.toLowerCase())
      );
      // Do something with the matchingObjects, such as updating state or displaying them in the UI
      setDcoursesbatch_name(matchingObjects);
    } else {
      setDcoursesbatch_name(dCoursebatch_name);
    }
  };
  // handle search function
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      // 👇 Get input value
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };
  // --------New code (Search Icon)----
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });
      txtBSearch.current.dispatchEvent(event);
    }
  };
  //-------end ------
  //chip data list view
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  //chips overall clear button
  const handleAllClear = () => {
    setSearchTerm("");
    setStatus([]);
    setLocation([]);
    setBatch_name([]);
    setSection([]);
    setUpdateChipData([]);
    setAppOn([]);
    setAppOn_due([]);
    setTypeOn([]);
    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
    });
    setAppDataDue({
      FDate: "",
      TDate: "",
      Days: "",
    });
    setUpdateListData(listData);
  };

  // filter apply button

  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "appliedOn") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        startDate: false,
      });
    } else if (name === "type") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "location") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        location: false,
      });
    } else if (name === "batch_name") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        batch_name: false,
      });
    } else if (name === "section") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        section: false,
      });
    } else if (name === "pay_duedate") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        pay_duedate: false,
      });
    }
  };

  //load list data for table
  function loadListdata() {
    let tempstatus = [];
    let temptypeon = [];
    let tempnumstatus = [];
    let tempTypenum = [];
    let templocation = "";
    let tempbatch_name = [];
    let tempsection = [];
    status.map((obj) => {
      tempstatus.push(obj.id);
    });
    typeOn.map((obj) => {
      temptypeon.push(obj.id);
    });
    location.map((obj) => {
      if (obj.name === "Online") {
        templocation = "1";
      } else {
        templocation = "0";
      }
    });
    batch_name.map((obj) => {
      tempbatch_name.push(obj.name);
    });
    section.map((obj) => {
      tempsection.push(obj.name);
    });
    // status array to number array

    tempnumstatus = tempstatus.map(Number);

    tempTypenum = temptypeon.map(Number);

    let statusFilter = {
      type: typeOn.length > 0 ? tempTypenum : "",
      location_type: location.length > 0 ? templocation : "",
      location: staff_loc_id ? staff_loc_id.toString() : "",
      section: section.length > 0 ? tempsection : "",
      // a_start_date: appOn.length > 0 ? appOn[0].fdate : "",
      // a_end_date: appOn.length > 0 ? appOn[0].edate : "",
      // p_start_date: appOn_due.length > 0 ? appOn_due[0].fdate : "",
      // p_end_date: appOn_due.length > 0 ? appOn_due[0].edate : "",
      search: searchTerm.length > 0 ? searchTerm : "",
      batch_name: batch_name.length > 0 ? tempbatch_name : "",
      user_id: "",
      // page_no: currentPage,
      // page_size: rowsPerPage,
      page_no: "",
      page_size: "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/purchase/pending/cash/payment", statusFilter)
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            admission_id: item.admission_id,
            name: item.name,
            email: item.email,
            phone_no: item.phone_no,
            location_name: item.location_name,
            type:
              item.type === 0
                ? "Course"
                : item.type === 1
                ? "Test Batch"
                : item.type === 3
                ? "Special Classes"
                : item.type === 2
                ? "Counselling"
                : item.type === 4
                ? "Mock Interview"
                : "Model Exam",
            batch_name: item.batch_name,
            section: item.section,
            paid_amount: item.paid_amount,
            balance_amt: item.balance_amt,
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
          const LocationList = updateListData
            .map((item) =>
              item.location_name !== null ? item.location_name : []
            )
            .flat();
          // Remove duplicates by converting the array to a Set and back to an array
          const uniqueLocationList = [...new Set(LocationList)];
          setDcourse(uniqueLocationList);
          setDcourses(uniqueLocationList);

          // batch name list

          const batch_name_list = updateListData
            .map((item) => (item.location !== null ? item.batch_name : []))
            .flat();
          // Remove duplicates by converting the array to a Set and back to an array
          const uniquebatch_nameList = [...new Set(batch_name_list)];
          setDcoursebatch_name(uniquebatch_nameList);
          setDcoursesbatch_name(uniquebatch_nameList);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setUpdateListData([]);
        return error;
      });
  }
  //load chip data
  function loadChipdata() {
    //setUpdateChipData([]);
    let tempArr = [];
    // setUpdateChipData(status);
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });

    filterType.map((obj) => {
      tempArr.push(obj);
    });

    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });

    filterApplyedDue.map((obj) => {
      tempArr.push(obj);
    });

    filterlocation.map((obj) => {
      tempArr.push(obj);
    });

    filterbatch_name.map((obj) => {
      tempArr.push(obj);
    });
    filtersection.map((obj) => {
      tempArr.push(obj);
    });

    setUpdateChipData(tempArr);
  }
  // applied on handlechange
  const handleAppliedOn = (e) => {
    const { name, value, checked } = e.target;
    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => ({ ...prevState, [name]: value }));
      const from = name === "FDate" ? value : appData.FDate;
      const to = name === "TDate" ? value : appData.TDate;
      const dateRange = `${from} - ${to}`;
      setAppOn([
        {
          name: dateRange,
          fdate: moment(from).format("YYYY-MM-DD"),
          edate: moment(to).format("YYYY-MM-DD"),
          type: "dateRange",
        },
      ]);
    } else if (name === "Days") {
      if (checked) {
        setAppData((prevState) => ({ ...prevState, [name]: value }));
      }
      // else {
      //   setAppOn(appOn.filter((item) => item !== value));
      // }
      if (value === "Today") {
        const today = new Date();
        setAppOn([
          {
            name: value,
            fdate: moment(today.toDateString()).format("YYYY-MM-DD"),
            edate: moment(today.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Yesterday") {
        const today = new Date(); // Get today's date
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        setAppOn([
          {
            name: value,
            fdate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            edate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Tweek") {
        const today = new Date(); // Get today's date
        const thisWeekStartDate = moment(today)
          .subtract(0, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const thisWeekEndDate = moment(today)
          .subtract(0, "week")
          .endOf("week")
          .toDate();
        setAppOn([
          {
            name: "This week",
            fdate: moment(thisWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Lweek") {
        const today = new Date(); // Get today's date
        const lastWeekStartDate = moment(today)
          .subtract(1, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const lastWeekEndDate = moment(today)
          .subtract(1, "week")
          .endOf("week")
          .toDate();
        setAppOn([
          {
            name: "Last week",
            fdate: moment(lastWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Tmonth") {
        const today = new Date(); // Get today's date
        const thisMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        ); // Get start date of this month
        const thisMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        );
        setAppOn([
          {
            name: "This month",
            fdate: moment(thisMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      } else if (value === "Lmonth") {
        const today = new Date();
        const lastMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        );
        const lastMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        );
        setAppOn([
          {
            name: "Last month",
            fdate: moment(lastMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRange",
          },
        ]);
      }
    }
  };

  const handleAppliedOnDue = (e) => {
    const { name, value, checked } = e.target;
    if (name === "FDate" || name === "TDate") {
      setAppDataDue((prevState) => ({ ...prevState, [name]: value }));
      const from = name === "FDate" ? value : appData.FDate;
      const to = name === "TDate" ? value : appData.TDate;
      const dateRange = `${from} - ${to}`;
      setAppOn_due([
        {
          name: dateRange,
          fdate: moment(from).format("YYYY-MM-DD"),
          edate: moment(to).format("YYYY-MM-DD"),
          type: "dateRange",
        },
      ]);
    } else if (name === "Days") {
      if (checked) {
        setAppDataDue((prevState) => ({ ...prevState, [name]: value }));
      }
      // else {
      //   setAppOn(appOn.filter((item) => item !== value));
      // }
      if (value === "Today") {
        const today = new Date();
        setAppOn_due([
          {
            name: value,
            fdate: moment(today.toDateString()).format("YYYY-MM-DD"),
            edate: moment(today.toDateString()).format("YYYY-MM-DD"),
            type: "dayRangeDue",
          },
        ]);
      } else if (value === "Yesterday") {
        const today = new Date(); // Get today's date
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        setAppOn_due([
          {
            name: value,
            fdate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            edate: moment(yesterday.toDateString()).format("YYYY-MM-DD"),
            type: "dayRangeDue",
          },
        ]);
      } else if (value === "Tweek") {
        const today = new Date(); // Get today's date
        const thisWeekStartDate = moment(today)
          .subtract(0, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const thisWeekEndDate = moment(today)
          .subtract(0, "week")
          .endOf("week")
          .toDate();
        setAppOn_due([
          {
            name: "This week",
            fdate: moment(thisWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRangeDue",
          },
        ]);
      } else if (value === "Lweek") {
        const today = new Date(); // Get today's date
        const lastWeekStartDate = moment(today)
          .subtract(1, "week")
          .startOf("week")
          .toDate(); // Get start date of last week
        const lastWeekEndDate = moment(today)
          .subtract(1, "week")
          .endOf("week")
          .toDate();
        setAppOn_due([
          {
            name: "Last week",
            fdate: moment(lastWeekStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastWeekEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRangeDue",
          },
        ]);
      } else if (value === "Tmonth") {
        const today = new Date(); // Get today's date
        const thisMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        ); // Get start date of this month
        const thisMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        );
        setAppOn_due([
          {
            name: "This month",
            fdate: moment(thisMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(thisMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRangeDue",
          },
        ]);
      } else if (value === "Lmonth") {
        const today = new Date();
        const lastMonthStartDate = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        );
        const lastMonthEndDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        );
        setAppOn_due([
          {
            name: "Last month",
            fdate: moment(lastMonthStartDate.toDateString()).format(
              "YYYY-MM-DD"
            ),
            edate: moment(lastMonthEndDate.toDateString()).format("YYYY-MM-DD"),
            type: "dayRangeDue",
          },
        ]);
      }
    }
  };
  // filter clear button
  const handleClear = (name) => {
    updateStateData();
    if (name === "appliedOn") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
      setIsOpen({
        ...isOpen,
        startDate: false,
      });
    } else if (name === "status") {
      // Clear the status array
      setStatus([]);
      filterStatus = [];
      setIsOpen({
        ...isOpen,
        status: false,
      });
      // setUpdateListData(listData);
    } else if (name === "type") {
      setTypeOn([]);
      filterType = [];

      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "location") {
      setLocation([]);
      filterlocation = [];
      setIsOpen({
        ...isOpen,
        location: false,
      });
    } else if (name === "batch_name") {
      setBatch_name([]);
      filterbatch_name = [];
      setIsOpen({
        ...isOpen,
        batch_name: false,
      });
    } else if (name === "section") {
      setSection([]);
      filtersection = [];

      setIsOpen({
        ...isOpen,
        section: false,
      });
    } else if (name === "pay_duedate") {
      setAppDataDue({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn_due([]);
      filterApplyedDue = [];
      setIsOpen({
        ...isOpen,
        pay_duedate: false,
      });
    }
    loadChipdata();
  };

  // //   checking once again  -  handle delete function
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "status") {
      setStatus(status.filter((item) => item.id !== chipToDelete.id));
      filterStatus = status.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "type") {
      setTypeOn(typeOn.filter((item) => item.id !== chipToDelete.id));
      filterType = typeOn.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "location") {
      setLocation(location.filter((item) => item.id !== chipToDelete.id));
      filterlocation = location.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "batch_name") {
      setBatch_name(batch_name.filter((item) => item.id !== chipToDelete.id));
      filterbatch_name = batch_name.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "section") {
      setSection(section.filter((item) => item.id !== chipToDelete.id));
      filtersection = section.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "dayRange") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    } else if (chipToDelete.type === "dayRangeDue") {
      setAppDataDue({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn_due([]);
      filterApplyedDue = [];
    } else {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
      setAppDataDue({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn_due([]);
      filterApplyedDue = [];
    }
    loadChipdata();
  };

  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => ({ ...prevState, [name]: dateFilter }));
      const from = name === "FDate" ? dateFilter : appData.FDate;
      const to = name === "TDate" ? dateFilter : appData.TDate;
      const dateRange = `${from} - ${to}`;
      setAppOn([
        {
          name: dateRange,
          fdate: moment(from).format("YYYY-MM-DD"),
          edate: moment(to).format("YYYY-MM-DD"),
          type: "dateRange",
        },
      ]);
    }
  };

  const handleChangeDateDue = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppDataDue((prevState) => ({ ...prevState, [name]: dateFilter }));
      const from = name === "FDate" ? dateFilter : appData.FDate;
      const to = name === "TDate" ? dateFilter : appData.TDate;
      const dateRange = `${from} - ${to}`;
      setAppOn_due([
        {
          name: dateRange,
          fdate: moment(from).format("YYYY-MM-DD"),
          edate: moment(to).format("YYYY-MM-DD"),
          type: "dateRange",
        },
      ]);
    }
  };

  //  filter box tootle function
  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        startDate: false,
        location: false,
        batch_name: false,
        section: false,
        category: false,
        pay_duedate: false,
        status: !prevState.status,
      }));
    } else if (boxName === "startDate") {
      setIsOpen((prevState) => ({
        section: false,
        location: false,
        batch_name: false,
        category: false,
        status: false,
        pay_duedate: false,
        startDate: !prevState.startDate,
      }));
    } else if (boxName === "section") {
      setIsOpen((prevState) => ({
        category: false,
        location: false,
        batch_name: false,
        status: false,
        startDate: false,
        pay_duedate: false,
        section: !prevState.section,
      }));
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        status: false,
        startDate: false,
        location: false,
        batch_name: false,
        section: false,
        pay_duedate: false,
        category: !prevState.category,
      }));
    } else if (boxName === "pay_duedate") {
      setIsOpen((prevState) => ({
        status: false,
        location: false,
        batch_name: false,
        startDate: false,
        section: false,
        category: false,
        pay_duedate: !prevState.pay_duedate,
      }));
    } else if (boxName === "location") {
      setIsOpen((prevState) => ({
        category: false,
        status: false,
        batch_name: false,
        section: false,
        startDate: false,
        pay_duedate: false,
        location: !prevState.location,
      }));
    } else if (boxName === "batch_name") {
      setIsOpen((prevState) => ({
        category: false,
        status: false,
        location: false,
        section: false,
        startDate: false,
        pay_duedate: false,
        batch_name: !prevState.batch_name,
      }));
    }
  };

  // generate pdf when user click download button

  // total table data  with pages
  const totalPages = Math.ceil(updateListData.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
    // setUpdatePag(true);
    // setUpdatePagDis(false);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
    // setUpdatePag(false);
    // setUpdatePagDis(true);
  };
  // page count handle
  const handlePageCount = (e) => {
    const { name, value, checked } = e.target;

    if (name === "pageCount") {
      setRowsPerPage(parseInt(value));
      setCurrentPage(1);
      setUpdateListData([]);
    }
    if (props.activeTab === 2) {
      loadListdata();
    }
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData.slice(start, end);

  //detail view for this list data
  const handleReadView = (user_id, batch_id, add_id, type) => {
    navigate(
      `/TransactionHistory/ViewAdmission/${user_id}/${batch_id}/${add_id}/${type}/0`
    );
  };

  const generatePDF = () => {
    const headers = [
      // "S.No",
      "Admission ID",
      "Name",
      // "Email ID",
      "Phone Number",
      // "Location",
      // "Type",
      "Batch Name",
      // "Section",
      "Fees Paid",
      "Balance Fee",
    ];
    const rows = csvData.map((item, index) => [
      // index + 1,
      item.admission_id ?? "-",
      item.name ?? "-",
      // item.email ?? "-",
      item.phone_no ?? "-",
      // item.location_name ?? "-",
      // item.type ?? "-",
      item.batch_name ?? "-",
      // item.section ?? "-",
      item.paid_amount ?? "-",
      item.balance_amt ?? "-",
    ]);
    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Pending Payment Data",
          headers,
          rows,
          filename: "PendingPayment.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Admission ID", key: "admission_id" },
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Phone Number", key: "phone_no" },
    { label: "Location", key: "location_name" },
    { label: "Type", key: "type" },
    { label: "Batch Name", key: "batch_name" },
    { label: "Section", key: "section" },
    { label: "Paid Amount", key: "paid_amount" },
    { label: "Balance Amount", key: "balance_amt" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={
        props.activeTab === 2
          ? "row tab-content mt-4"
          : "row tab-content mt-4 hide "
      }
      id="ex2-content"
    >
      <div
        className={
          props.activeTab === 2
            ? "tab-pane fade show active col-md-12"
            : "tab-pane fade col-md-12 "
        }
      >
        <div className="row ms-1">
          <div className="col-lg-6 col-md-6">
            <div class="input-group">
              <input
                ref={txtBSearch} //new
                type="text"
                class="Inputs_search"
                id="SearchInput"
                name="SearchInput"
                placeholder="Search by ID, Name, Email, Phone No."
                onKeyDown={handleSearch}
              />
              <span
                class="input-group-text"
                id="SearchInput"
                onClick={handleSearchFocus}
              >
                <span className="material-icons" onClick={handleSearchFocus}>
                  search
                </span>
              </span>
            </div>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul className="List-Button">
              <li class="ListBtnItems">
                <CustomDownloadButton
                  csvListData={csvData?.length > 0 ? csvData : ""}
                  headers={csvHeaders}
                  iconName=" file_download "
                  filename={"PendingPayment.csv"}
                  csvName="Download as CSV"
                />
              </li>
              <li class="ListBtnItems primaryButton" onClick={generatePDF}>
                <span className="material-icons me-1 align-middle text-white">
                  file_download
                </span>
                Download as PDF
              </li>
            </ul>
          </div>
        </div>
        {updateChipData.length > 0 ? (
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-xs-12 " id="paperil">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {updateChipData.map((data, index) => {
                  let icon;
                  let key = "" + data.name;
                  return (
                    <ListItem key={data}>
                      <Chip
                        icon={icon}
                        label={key}
                        onDelete={handleDelete(data, index)}
                      />
                    </ListItem>
                  );
                })}

                <ListItem>
                  {/* <Chip
                      label=" Clear All Filters"
                      onClick={handleAllClear}
                    /> */}
                  <a className="allclear" href="#" onClick={handleAllClear}>
                    Clear All Filters
                  </a>
                </ListItem>
              </Paper>
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <div className="row mt-3 mx-0">
          <div className="col-md-12 table-responsive px-0">
            <table className="table" id="example">
              <thead>
                <tr>
                  <th id="th" style={{ width: "5%" }}>
                    {" "}
                    <span className="text_th">S.No</span>{" "}
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      {" "}
                      import_export{" "}
                    </span>
                  </th>
                  <th id="th">
                    {" "}
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "admission_id")}
                    >
                      {" "}
                      Admission ID
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "admission_id")}
                    >
                      {" "}
                      import_export{" "}
                    </span>
                  </th>
                  <th id="th" style={{ width: "7%" }}>
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "name")}
                    >
                      Name
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "name")}
                    >
                      {" "}
                      import_export{" "}
                    </span>{" "}
                  </th>

                  <th id="th" style={{ width: "4%" }}>
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "email_id")}
                    >
                      Email ID
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "email_id")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th" style={{ width: "7%" }}>
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "phone_no")}
                    >
                      Phone Number
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "phone_no")}
                    >
                      import_export
                    </span>
                  </th>

                  <th id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "location_name")}
                    >
                      Location
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "location_name")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      class={` align-middle material-icons  ${
                        location.length > 0 ? "active_icons" : ""
                      }`}
                      onClick={(e) => handleFilter(e, "location")}
                    >
                      filter_list
                    </span>
                    {isOpen.location === true && (
                      <div className="filterBoxs p-1">
                        <div className="row ms-1">
                          <div className="col-lg-12 col-md-12">
                            <div class="input-group searchInputsss">
                              <input
                                type="text"
                                class="Inputs "
                                id="SearchFilterInputs"
                                name="SearchFilterInputs"
                                placeholder="Search Here"
                                // onChange={handleSearch}
                                onKeyDown={handleFilterCourseSearch}
                              />
                              <span class="input-group-text" id="SearchInput">
                                <span className="material-icons">search</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        {dCourses.map((el) => (
                          <div className="row mt-2">
                            <div className="col-md-12">
                              <div class="form-check ms-3">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  name={el} // Use el.label to set the name and value
                                  value={el}
                                  id={el}
                                  checked={location.some((element) => {
                                    if (element.name === el) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "location")
                                  }
                                />
                                <label
                                  class="form-check-label PinkText"
                                  for="defaultCheck1"
                                >
                                  {el}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))}
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4  col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("location")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              onClick={() => handleApplyFilter("location")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </th>
                  <th id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "type")}
                    >
                      Type
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "type")}
                    >
                      import_export
                    </span>
                    <span
                      class={` align-middle material-icons  ${
                        typeOn.length > 0 ? "active_icons" : ""
                      }`}
                      onClick={(e) => handleFilter(e, "category")}
                    >
                      filter_list
                    </span>
                    {isOpen.category === true && (
                      <div className="filterBoxTwo p-1">
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="course"
                                value="0"
                                checked={typeOn.some((element) => {
                                  if (element.id === "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "course")
                                }
                                id="course"
                              />
                              <label
                                class="form-check-label pb-0 pt-0 align-top YellowText"
                                for="defaultCheck1"
                              >
                                Course
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="TestBatch"
                                value="1"
                                checked={typeOn.some((element) => {
                                  if (element.id === "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "TestBatch")
                                }
                                id="TestBatch"
                              />
                              <label
                                class="form-check-label pb-0 pt-0 align-top GreenText"
                                for="defaultCheck1"
                              >
                                Test Batch
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="SpecialClass"
                                value="3"
                                checked={typeOn.some((element) => {
                                  if (element.id === "3") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "SpecialClass")
                                }
                                id="SpecialClass"
                              />
                              <label
                                class="form-check-label pb-0 pt-0 align-top  YellowText"
                                for="defaultCheck1"
                              >
                                Special Class
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="Counselling"
                                value="2"
                                checked={typeOn.some((element) => {
                                  if (element.id === "2") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "Counselling")
                                }
                                id="Counselling"
                              />
                              <label
                                class="form-check-label pb-0 align-top pt-0 RedText"
                                for="defaultCheck1"
                              >
                                Counselling
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="MockInterview"
                                value="5"
                                checked={typeOn.some((element) => {
                                  if (element.id === "5") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "MockInterview")
                                }
                                id="MockInterview"
                              />
                              <label
                                class="form-check-label pb-0 align-top pt-0 RedText"
                                for="defaultCheck1"
                              >
                                Mock Interview
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="ModelExam"
                                value="4"
                                checked={typeOn.some((element) => {
                                  if (element.id === "4") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "ModelExam")
                                }
                                id="ModelExam"
                              />
                              <label
                                class="form-check-label pb-0 align-top pt-0 RedText"
                                for="defaultCheck1"
                              >
                                Model Exam
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4  col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("type")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              disabled={typeOn.length === 0 ? true : false}
                              onClick={() => handleApplyFilter("type")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </th>
                  <th id="th" style={{ width: "4%" }}>
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "batch_name")}
                    >
                      Batch Name
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "batch_name")}
                    >
                      import_export
                    </span>
                    <span
                      onClick={(e) => handleFilter(e, "batch_name")}
                      class={` align-middle material-icons ${
                        batch_name.length > 0 ? "active_icons" : ""
                      }`}
                    >
                      filter_list
                    </span>
                    {isOpen.batch_name === true && (
                      <div className="filterBoxs p-1">
                        <div className="row ms-1">
                          <div className="col-lg-12 col-md-12">
                            <div class="input-group searchInputsss">
                              <input
                                type="text"
                                class="Inputs "
                                id="SearchFilterInputs"
                                name="SearchFilterInputs"
                                placeholder="Search Here"
                                // onChange={handleSearch}
                                onKeyDown={handleFilterCourseBSearch}
                              />
                              <span class="input-group-text" id="SearchInput">
                                <span className="material-icons">search</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        {dCoursesbatch_name.map((el) => (
                          <div className="row mt-2">
                            <div className="col-md-12">
                              <div class="form-check ms-3">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  name={el} // Use el.label to set the name and value
                                  value={el}
                                  id={el}
                                  checked={batch_name.some((element) => {
                                    if (element.name === el) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "batch_name")
                                  }
                                />
                                <label
                                  class="form-check-label PinkText"
                                  for="defaultCheck1"
                                >
                                  {el}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))}
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4  col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("batch_name")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              onClick={() => handleApplyFilter("batch_name")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </th>

                  <th id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "section")}
                    >
                      Section
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "section")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      class={` align-middle material-icons  ${
                        section.length > 0 ? "active_icons" : ""
                      }`}
                      onClick={(e) => handleFilter(e, "section")}
                    >
                      filter_list
                    </span>
                    {isOpen.section === true && (
                      <div className="filterBoxs p-1">
                        <div className="row mt-4">
                          <div className="col-md-3">
                            <div class="form-check ms-2">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="A"
                                value="A"
                                id="A"
                                checked={location.some((element) => {
                                  if (element.name === "A") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) => handleCheckboxChange(e, "A")}
                              />
                              <label
                                class="form-check-label "
                                for="defaultCheck1"
                              >
                                A
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div class="form-check ">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="B"
                                value="B"
                                id="B"
                                checked={location.some((element) => {
                                  if (element.name === "B") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) => handleCheckboxChange(e, "B")}
                              />
                              <label
                                class="form-check-label "
                                for="defaultCheck1"
                              >
                                B
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div class="form-check ">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="C"
                                value="C"
                                id="C"
                                checked={location.some((element) => {
                                  if (element.name === "C") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) => handleCheckboxChange(e, "C")}
                              />
                              <label
                                class="form-check-label "
                                for="defaultCheck1"
                              >
                                C
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div class="form-check ">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="D"
                                value="D"
                                id="D"
                                checked={location.some((element) => {
                                  if (element.name === "D") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) => handleCheckboxChange(e, "D")}
                              />
                              <label
                                class="form-check-label "
                                for="defaultCheck1"
                              >
                                D
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4  col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("section")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              onClick={() => handleApplyFilter("section")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </th>

                  <th id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "paid_amount")}
                    >
                      Fees Paid
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "paid_amount")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "balance_amt")}
                    >
                      Balance
                      <br />
                      Fee
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "balance_amt")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th">
                    <span className="text_th">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentData.length === 0 ? (
                  <tr>
                    <td colspan="12" style={{ textAlign: "center" }}>
                      No record to display
                    </td>
                  </tr>
                ) : (
                  currentData.map((course, index) => (
                    <tr key={index} title={course.admission_id}>
                      <td id="td">{course.serialNumber}</td>
                      <td id="td">
                        {course.admission_id ? course.admission_id : "_"}
                      </td>
                      <td id="td">{course.name}</td>
                      <td id="td">{course.email_id}</td>
                      <td id="td">{course.phone_no}</td>
                      <td id="td">{course.location_name}</td>
                      {course.type === 0 && (
                        <td id="td">
                          <span>course</span>
                        </td>
                      )}
                      {course.type === 1 && (
                        <td id="td">
                          <span>Test Batch</span>
                        </td>
                      )}
                      {course.type === 2 && (
                        <td id="td">
                          <span>Counselling</span>
                        </td>
                      )}
                      {course.type === 3 && (
                        <td id="td">
                          <span>Special classes</span>
                        </td>
                      )}
                      {course.type === 4 && (
                        <td id="td">
                          <span>Model exam </span>
                        </td>
                      )}

                      {course.type === 5 && (
                        <td id="td">
                          <span>Mock Interview </span>
                        </td>
                      )}
                      <td id="td"> {course.batch_name}</td>
                      <td id="td">{course.section}</td>
                      <td id="td"> {course.paid_amount}</td>
                      <td id="td"> {course.balance_amt}</td>

                      <td id="td" style={{ width: "15%" }}>
                        <button
                          type="button"
                          onClick={() => handlePayFee(course)}
                          className="PyNowBtn"
                        >
                          <span class="material-icons">send</span>
                          <Link className="PyNowBtnLink">Pay Now</Link>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* <div className="row mt-3 ms-1 me-1">
          <div className="col-md-12">
            <div className="pag w-100 dflexcenter">
              <span className="ipage">Items Per Page</span>
              <select
                name="pageCount"
                id="pageCount"
                defaultValue={rowsPerPage}
                onChange={handlePageCount}
                className="ms-2"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span className="pagenumber ms-2">
                {" "}
                {currentPage * rowsPerPage + 1 - rowsPerPage} -{" "}
              
                {updateListData.length < currentPage * rowsPerPage
                  ? updateListData.length
                  : currentPage * rowsPerPage}{" "}
                of {updateListData.length}
              </span>
              <button
                className="prev_button ms-2 me-2"
                onClick={(e) => handlePrev(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <span class="material-icons">chevron_left</span>
              </button>
              <button
                className="prev_button"
                onClick={() => handleNext(currentPage + 1)}
                disabled={updatePagDis}
              >
                <span class="material-icons">chevron_right</span>
              </button>
            </div>
          </div>
        </div> */}
        <div className="row mt-3 ms-1 me-1">
          <div className="col-md-12">
            <div className="pag w-100 dflexcenter">
              <span className="ipage">Items Per Page</span>
              <select
                name="pageCount"
                id="pageCount"
                defaultValue={rowsPerPage}
                onChange={handlePageCount}
                className="ms-2"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span className="pagenumber ms-2">
                {" "}
                {updateListData.length > 0
                  ? currentPage * rowsPerPage + 1 - rowsPerPage
                  : 0}{" "}
                -{/* {currentPage * rowsPerPage} of {updateListData.length} */}
                {updateListData.length < currentPage * rowsPerPage
                  ? updateListData.length
                  : currentPage * rowsPerPage}{" "}
                of {updateListData.length}
              </span>
              <button
                className="prev_button ms-2 me-2"
                onClick={(e) => handlePrev(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <span class="material-icons">chevron_left</span>
              </button>
              <button
                className="prev_button"
                onClick={() => handleNext(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <span class="material-icons">chevron_right</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CashPendingPayment;
